module.exports = __webpack_public_path__ + "img/Small-Horizontal-Rectangular-Attachment-35.f48a999d.png";